import { Button, Container, Section } from 'react-bulma-components';

import React from 'react';
import { useAuth } from 'react-oidc-context';

export default function Login() {
  const auth = useAuth();

  return (
    <Section>
      <Container>
        <Button color="success" onClick={() => auth.signinRedirect()}>
          Log in
        </Button>
      </Container>
    </Section>
  );
}
